import { Colors } from '@oy/uicore';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React from 'react';
import { Tooltip } from 'react-tooltip';
import styles from './TablePill.module.css';

const ColorMap = {
  Gray: {
    color: Colors.BLACK100,
    backgroundColor: Colors.BLACK10,
  },
  Purple: {
    color: Colors.PURPLE100,
    backgroundColor: Colors.PURPLE10,
  },
  Yellow: {
    color: Colors.BLACK100,
    backgroundColor: Colors.YELLOW40,
  },
  Green: {
    color: Colors.GREEN100,
    backgroundColor: Colors.GREEN10,
  },
  Red: {
    color: Colors.RED100,
    backgroundColor: Colors.RED10,
  },
  Blue: {
    color: Colors.BLUE100,
    backgroundColor: Colors.BLUE10,
  },
  Orange: {
    color: Colors.ORANGE100,
    backgroundColor: Colors.ORANGE10,
  },
};

type TablePillColor = typeof ColorMap[keyof typeof ColorMap];

const TooltipID = 'table-pill-tooltip';

const TablePill = ({
  children,
  color = ColorMap.Gray,
  className,
  description,
  ...props
}: Omit<JSX.IntrinsicElements['span'], 'color'> & {
  description?: string;
  color?: TablePillColor;
}) => {
  return (
    <span
      {...props}
      style={{ ...color }}
      className={classNames(
        'font-body-MdSemibold',
        styles.container,
        className,
      )}
    >
      {children}
      {description && (
        <>
          <SystemIcon
            name="information"
            size={16}
            color={color.color}
            data-tooltip-id={TooltipID}
            data-tooltip-content={description}
          />
          <Tooltip
            id={TooltipID}
            place="bottom"
            className={classNames('font-body-MdRegular', styles.tooltip)}
          />
        </>
      )}
    </span>
  );
};

export default Object.assign(TablePill, {
  Color: ColorMap,
});
